import { createTranslatedText } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import {
   DetailQuestionViewModel,
   FieldScope,
   MedicalProfileTabFormController,
} from '../../tab/MedicalProfileTab.types';
import { answerToFormValue } from '../../tab/MedicalProfileAnswer.utils';
import { createFormFieldName } from '../../tab/MedicalProfileTab.utils';

type SingleChoiceFieldProps = Pick<MedicalProfileTabFormController, 'register'> & {
   readonly templateCode: string;
   readonly question: DetailQuestionViewModel;
   readonly disabled: boolean;
   readonly scope?: FieldScope;
};

export const SingleChoiceField = (props: SingleChoiceFieldProps): JSX.Element => {
   const items: RadioGroupItem<string>[] = (props.question.config?.options ?? []).map((option) => ({
      id: option.code,
      label: createTranslatedText(option.label),
   }));

   return (
      <RadioGroup
         testId={`detailQuestion-${props.question.questionId}`}
         label={createTranslatedText(props.question.content)}
         items={items}
         controller={props.register(createFormFieldName(props.templateCode, props.question.questionId, props.scope))}
         defaultValue={answerToFormValue(props.question.answerType, props.question.existingAnswer) as string | null}
         disabled={props.disabled}
         required={props.question.required}
         horizontal
      />
   );
};
